import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./styles/checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    selection = new SelectionModel(true, []);

    /**
     * Установка надписи
     * @param options
     */
    setOptions(options) {
        this.field.label = options;
    }

    /**
     * Конструктор
     */
    constructor() {
    }

    ngOnInit() {
        if (this?.field?.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
            });
        }

        const value = this.group.get(this.field.name).value;
        if (value && value.length) {
            value.forEach(v => {
                this.selection.select(v);
            });
        } else {
            this.selection.clear();
        }
    }

    /**
     * Изменение чекбокса
     * @param event событие
     * @param value значение
     */
    changeCheckbox(event, value) {
        if (event) {
            this.selection.toggle(value);
            this.group.get(this.field.name).setValue(this.selection.selected);
        }
    }

    /**
     * Соответствует ли количество выбранных элементов общему количеству строк.
     */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.field.options && this.field.options.length ? this.field.options.length : 0;
        return numSelected === numRows;
    }

    /**
     * Выбирает все строки, если они не все выделены; в противном случае снимает выбор.
     */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.field.options.forEach(row => this.selection.select(
                row[this.field.optionsName ? row[this.field.optionsName] : row.value]
            ));
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled: boolean) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}
